/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const capacityPerformanceEnumsAffectedRedundancyLevelOptionEnum = {
    NPlus1: 'NPlus1',
    V2N: 'V2N',
    SinglePointOfFailure: 'SinglePointOfFailure',
    Other: 'Other',
} as const;

export type CapacityPerformanceEnumsAffectedRedundancyLevelOptionEnumKey =
    (typeof capacityPerformanceEnumsAffectedRedundancyLevelOptionEnum)[keyof typeof capacityPerformanceEnumsAffectedRedundancyLevelOptionEnum];

export type CapacityPerformanceEnumsAffectedRedundancyLevelOption =
    CapacityPerformanceEnumsAffectedRedundancyLevelOptionEnumKey;
